import script from "./AddGlobalGroupsFieldGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./AddGlobalGroupsFieldGroup.vue?vue&type=script&setup=true&lang=js"

import "./AddGlobalGroupsFieldGroup.vue?vue&type=style&index=0&id=7bf3013f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bf3013f"]])

export default __exports__